import { AlertColor } from '@mui/material'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '..'
import { ICampaign } from '../../types/influencerType'

export interface IReviewSlice {
  message: string | undefined
  severity: AlertColor | undefined
  shouldOpen: boolean
  status: string
  isPaidFeatureEnabled: boolean
  campaignAddEditModalOpen: boolean
  campaigns: ICampaign[]
}

const initialState: IReviewSlice = {
  status: 'idle',
  shouldOpen: false,
  message: undefined,
  severity: undefined,
  isPaidFeatureEnabled: false,
  campaignAddEditModalOpen: false,
  campaigns: [],
}

export const restaurantInfluencerSlice = createSlice({
  name: 'restaurant-influencer',
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.shouldOpen = action.payload
    },
    setIsPaidFeatureEnabled: (state, action: PayloadAction<boolean>) => {
      state.isPaidFeatureEnabled = action.payload
    },
    setCampaignAddEditModalOpen: (state, action: PayloadAction<boolean>) => {
      state.campaignAddEditModalOpen = action.payload
    },
    setCampaign: (state, action: PayloadAction<ICampaign>) => {
      state.campaigns.push(action.payload)
    },

    clearData: () => initialState,
  },
})

export const selectIsLoading = (state: RootState): boolean =>
  state?.restaurantInfluencer?.status === 'loading'
export const selectShouldOpen = (state: RootState): boolean =>
  state?.restaurantInfluencer?.shouldOpen
export const selectMessage = (state: RootState): string | undefined =>
  state?.restaurantInfluencer?.message
export const selectSeverity = (state: RootState): AlertColor | undefined =>
  state?.restaurantInfluencer?.severity
export const selectIsPaidFeatureEnabled = (state: RootState): boolean =>
  state?.restaurantInfluencer?.isPaidFeatureEnabled
export const selectCampaignAddEditModalOpen = (state: RootState): boolean =>
  state?.restaurantInfluencer?.campaignAddEditModalOpen
export const selectCampaigns = (state: RootState): ICampaign[] =>
  state?.restaurantInfluencer?.campaigns

export const {
  setOpen,
  setIsPaidFeatureEnabled,
  setCampaign,
  setCampaignAddEditModalOpen,
  clearData,
} = restaurantInfluencerSlice.actions

export default restaurantInfluencerSlice.reducer
